/**
 * 반응형 레이아웃 훅
 *
 * 브라우저 창 크기를 감지하여 현재 디바이스 타입을 판별한다.
 * - mobile: 768px 미만
 * - tablet: 768px ~ 1024px
 * - desktop: 1024px 초과
 *
 * resize 이벤트를 구독하여 실시간으로 상태를 업데이트한다.
 */
import { useState, useEffect, useMemo } from 'react';

// ─── 브레이크포인트 상수 ─────────────────────────────────────
const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
};

/**
 * 반응형 레이아웃 훅
 * @returns {{ isMobile: boolean, isTablet: boolean, isDesktop: boolean, width: number }}
 */
const useResponsive = () => {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1280
  );

  useEffect(() => {
    /** 창 크기 변경 핸들러 */
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /** 디바이스 타입 판별 */
  const deviceType = useMemo(() => {
    return {
      isMobile: width < BREAKPOINTS.MOBILE,
      isTablet: width >= BREAKPOINTS.MOBILE && width <= BREAKPOINTS.TABLET,
      isDesktop: width > BREAKPOINTS.TABLET,
    };
  }, [width]);

  return {
    ...deviceType,
    width,
  };
};

export default useResponsive;
